import { sanitizeUrl } from 'aa/helpers/sanitizeUrl';

const redirectUrlWhitelist = ['/account/cadence/', '/account/direct/', '/account/tier/'];

export default {
    methods: {
        validateRedirectUrl(redirectUrl) {
            if (
                redirectUrl &&
                redirectUrlWhitelist.some((whitelistUrl) => redirectUrl.includes(whitelistUrl))
            ) {
                return sanitizeUrl(redirectUrl, { requireRelativeUrl: true });
            }

            return null;
        },
    },
};
